/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaProductSkuViewProps } from './citta-product-sku';

/**
 *
 * ICittaProductSkuView component
 * @extends {React.PureComponent<ICittaProductSkuViewProps>}
 */
export class ICittaProductSkuView extends React.PureComponent<ICittaProductSkuViewProps> {

    public render(): JSX.Element | null {
        const { ProductSkuContainer, ProductSkuNode, SkuTitleTextNode } = this.props;

        return (
            <Module {...ProductSkuContainer} >
                <Node {...SkuTitleTextNode} />
                <Node {...ProductSkuNode} />
            </Module>
        );
    }
}
export default ICittaProductSkuView;